import React, { useState } from 'react'
import { Input, FormCustom, SwitchToggle } from '../../Components/Form/Form'

const PeriodForm = ({ data, onSubmit, disablebSubmit, loadSubmit }) => {
    const [row, setRow] = useState({
        p_id_period: data.id_period,
        p_name_period: data.name_period,
        p_state_period: data.state_period
    })

    return <FormCustom dataSubmit={row} onSubmit={onSubmit} disablebSubmit={disablebSubmit} loadSubmit={loadSubmit}>
        <Input
            text="Descripción"
            placeholder="Descripción"
            classNameParent="col-12 mt-2 mb-2"
            required
            invalid="El campo es obligatorio."
            defaultValue={data.name_period}
            onChange={e => setRow({ ...row, p_name_period: e.currentTarget.value })}
            maxLength={150}
        />
        <SwitchToggle
            classNameParent="col-12 mb-2"
            id="period_state"
            defaultChecked={parseInt(row.p_state_period) === 1}
            onChange={e => setRow({ ...row, p_state_period: e.currentTarget.checked ? 1 : 0 })}
        />
    </FormCustom>
}

PeriodForm.defaultProps = {
    data: {
        id_period: '',
        name_period: '',
        state_period: 1,
    },
    onSubmit: () => {},
    loadSubmit: false
}

export default PeriodForm;